<template>
  <div class="chat-conversation" ref="chatConversation">
    <div
      v-for="(message, index) in messages"
      :key="index"
      :class="['message', message.role]"
    >
      <div v-if="message.role === 'assistant'" class="ai-icon" :style="aiIconStyle"></div>

      <div class="chat-wrapper">
        <div v-if="message.html_content" class="chat-message">
          <div
            class="markdown-body"
            v-html="message.html_content"
          ></div>
        </div>

        <div v-else class="message-text">
          {{ message.content }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import hljs from 'highlight.js'
import { onMounted, watch, nextTick } from "vue"
import "@/assets/styles/dracula.css"
 
export default {
  name: "ChatConversation",
 
  props: {
    messages: {
      type: Array,
      required: true
    },
    companyInformation: {
      type: Object,
      default: null
    }
  },
  computed: {
    aiIconStyle() {
      const faviconUrl = this.companyInformation?.favicon || require('@/assets/logo.svg');
      return {
        backgroundImage: `url(${faviconUrl})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: 'contain'
      };
    }
  },
  setup(props) {
    const injectCopyButtons = () => {
      const codeBlocks = document.querySelectorAll('div.codehilite pre code')

      codeBlocks.forEach((block) => {
        const wrapper = block.closest('.codehilite')
        if (!wrapper || wrapper.querySelector('.copy-btn')) return

        const button = document.createElement('button')
        button.className = 'copy-btn'
        button.innerText = 'Copy'

        button.onclick = () => {
          navigator.clipboard.writeText(block.innerText.trim())
          button.innerText = 'Copied!'
          setTimeout(() => {
            button.innerText = 'Copy'
          }, 1500)
        }

        wrapper.appendChild(button)
      })
    }
    onMounted(async () => {
      await nextTick()
      injectCopyButtons()
    })

     watch(
      () => props.messages,
      async () => {
        await nextTick();
        setTimeout(() => {
          injectCopyButtons();
      }, 50);
      },
      { deep: true, immediate: true }
    )

    return {}
  },

  methods: {
    scrollToBottom() {
      const el = this.$refs.chatConversation;
      if (!el) return;

      el.scrollTo({
        top: el.scrollHeight,
        behavior: 'smooth'
      });
    },
    extractLanguage(text) {
      const match = text.match(/```([a-zA-Z]*)/)
      return match && match[1] ? match[1] : 'plaintext'
    },

    highlightCode(text) {
      const code = text.replace(/```[a-zA-Z]*\n|```/g, '')
      return hljs.highlightAuto(code).value
    },

    copyCode(text) {
      const code = text.replace(/```[a-zA-Z]*\n|```/g, '')
      navigator.clipboard.writeText(code).then(() => {
        alert('Code copied to clipboard')
      })
    }
  },

 
  watch: {
    'messages.length'() {
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      });
    }
  },

  mounted() {
    this.scrollToBottom();
    console.log('Messages received in ChatConversation.vue:', this.messages)
  }
}
</script>
 
<style>
.codehilite {
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 1rem;
  margin: 1.5rem 0;
  font-family: 'Fira Code', Menlo, Consolas, monospace;
  font-size: 0.95rem;
  overflow-x: auto;
  position: relative;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

/* Remove inner background from pre if needed */

.codehilite pre code {
  font-size: 0.95rem;
  padding: 0;
  line-height: 1.4;
  background: none;
  border: none;
}


/* Style the copy button */
.copy-btn {
  position: absolute;
  top: 8px;
  right: 12px;
  background: none;
  border: none;
  color: #666;
  font-size: 12px;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s ease;
  z-index: 1;
}

.copy-btn:hover {
  opacity: 1;
  color: #000;
}


.chat-message {
  margin-bottom: 20px;
}

.markdown-body pre,
.codehilite pre {
  white-space: pre-wrap;
  word-break: break-all;
  overflow-x: hidden;
}

pre code.language-plaintext{
  white-space: pre-wrap;
  word-break: break-all;
  overflow-x: hidden;
}
.chat-conversation {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  overflow-y: auto;
  padding: 1rem 2rem;
  font-family: Arial, sans-serif;
  max-height: 80vh;
  height: calc(vh - 6rem); 
  padding-bottom: calc(1rem + 4rem); 
}

.chat-conversation::-webkit-scrollbar {
  display: none;
}

.message {
  display: flex;
  align-items: top;
  margin-bottom: 20px;
}

.message.user {
  justify-content: flex-start !important;
  align-items: flex-start !important;
}

.message.ai {
  justify-content: flex-start;
}

.ai-icon {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  margin-right: 10px;
  margin-left: 100px;
}

.message-text{
  
  word-break: break-word;
  overflow-wrap:anywhere;
  text-overflow: unset;
  font-size: 14px;

  max-width: 90%;
  border-radius: 10px;
  padding: 8px 12px;
  margin-right: 10px;
}

.message-text {
  
   max-width: 90%;
  margin-right: 10px;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: anywhere; 
  line-height: 1.4rem;
  white-space: normal;
}

.message.assistant .message-text {
  background-color: #f4f4f4; 
  margin-left: 10px;
  border-radius: 10px;
  padding: 10px 15px;
  width: auto;
  max-width: 90%;

}

 .message.user .message-text,
.message.user .chat-message {
  background-color: #f4f4f4;
  margin-right: 10px;
  width: auto;
  max-width: 90%;
  padding: 13px;
  border-radius: 15px;
  font-size: 14px;
  line-height: 1.4rem;
}

/* AI messages without background color */
.message.ai .message-text {
  margin-left: 10px; /* Adjust to shift more to the right */
  background-color: transparent;
  color: inherit; /* Inherit the text color based on mode */
}

.message-code {
  background-color: #2d2d2d;
  color: #f8f8f2;
  font-family: monospace;
  padding: 15px;
  border-radius: 10px;
  position: relative;
}

.code-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.language-label {
  color: #f8f8f2;
  font-size: 0.9rem;
  font-weight: bold;
}


pre {
  white-space: pre-wrap;       /* Wraps text inside the code block */
  word-wrap: break-word;       /* Breaks long words onto the next line */
  overflow-wrap: break-word;   /* Ensures it wraps even in flexible layouts */
}
.example-container {
  display: flex;
  flex-direction: column;
  width: 100%; /* Take full width */
  max-width: 600px; /* Limit maximum width */
  margin: 0 auto; /* Center the container */
}

.example-item {
  width: 280px;
  height: 48px;
  background: #F7F9FB;
  border-radius: 8px;
  padding: 4px 8px;
  color: #1C1C1C;
  font-size: 14px;
  font-family: Inter, sans-serif;
  line-height: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.example-item:hover {
  background-color: #f0f0f0; /* Change background on hover */
}

.example-input {
  display: inline-block; /* Similar to example items */
  max-width: 100%; /* Prevent overflow from the container */
  white-space: nowrap; /* Stop input wrapping */
  overflow: hidden; /* Hide overflowing text */
  text-overflow: ellipsis; /* Add "..." for truncation on overflow */
  padding: 10px; /* Padding for user convenience */
  font-size: 14px; /* Slightly smaller font for inputs */
  margin-top: 10px; /* Separate it visually from example items */
  border: 1px solid #ddd;
  border-radius: 5px;
  box-sizing: border-box; /* Include padding in the width calculation */
}
@media (max-width: 768px) {
  .example-item,
  .example-input {
    font-size: 12px; /* Slightly smaller font for responsiveness */
    max-width: 100%; /* Ensure items fit the screen width */
    white-space: nowrap;
    margin-right: 0;
    margin-left: 0;  
  }


@media (max-width: 480px) {
  .example-item,
  .example-input {
    font-size: 11px; /* Further reduce font size on very small screens */
    max-width: 100%; /* Ensure space for both items and inputs */
    text-overflow: ellipsis; /* Retain truncation behavior */
  }
}

  /*.chat-conversation {
    max-height: 80vh; /* Limit the chat height 
    overflow-y: auto;  Enable scrolling for large chat histories 
  } */
}

</style>